// 没有迁移想用paas 能力
import { HEADER_PARAMS_KEYS } from 'fe-coms-share/paas/constants'
import { requestTemplate, requestExport } from './request'
import {popoverStatus} from '../../../../header-process-popover/popover-status.js'
import i18n from './i18n'

const Message = Vue.prototype.$message
const pageText = window.fe.getPageText(i18n)

export default async function exportPower (params) {
  const template = await requestTemplate({
    objectApiName: params.objectApiName, // 当前对象
    buttonApiName: params.buttonApiName // 按钮apiName
  })
  if (!template) {
    Message({
      type: 'error',
      message: pageText.templateIncorrect
    })
    return
  }
  const query = {
    options: params.options, // 搜索条件 包一层 {conditionListDefault: {}}
    objectApiName: params.objectApiName,
    operationApiName: params.operationApiName // 操作权
  }
  const isOk = await requestExport(query, {
    'apaas-template-api-name': template.templateApiName,
    // 'apaas-tenant-type': this.tenantType,
    'apaas-tab-api-name': params.tab, // 当前tab
    // 'apaas-layout-api-name': this.layoutApiName,
    [HEADER_PARAMS_KEYS.menuApiName]: params.menuApiName, // menuApiName
    [HEADER_PARAMS_KEYS.tenantType]: params.tenantType, // 租户平台
    [HEADER_PARAMS_KEYS.objectApiName]: params.objectApiName, // 
    [HEADER_PARAMS_KEYS.layoutApiName]: params.layoutApiName, // 布局
    [HEADER_PARAMS_KEYS.operationApiName]: params.operationApiName 
  })
  
  Message({
    type: 'success',
    message: params.successTip || pageText.currentFilter
  })
  isOk && popoverStatus.show()
}